import React from 'react';
import { Checkbox } from '@fiverr-private/forms';

interface FormCheckboxProps {
  value: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  name?: string;
  indeterminate?: boolean;
  checked?: boolean;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  value,
  onChange,
  onBlur,
  children,
  disabled = false,
  name,
  indeterminate = false,
  checked,
  ...rest
}) => (
  <Checkbox
    checked={checked ?? value}
    onChange={onChange}
    onBlur={onBlur}
    disabled={disabled}
    name={name}
    indeterminate={indeterminate}
    {...rest}
  >
    {children}
  </Checkbox>
);

export default FormCheckbox;
